// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New info component */
.infobox-container {
  font-family: "Roboto Mono", sans-serif;
  font-size: smaller;
  font-weight: 300;
  letter-spacing: 2px;
  width: 50%;
  background: rgba(30, 30, 30, 0.5);
  left: 50px;
  border-radius: 8px;
  display: block;
  position: absolute;
  top: 80px;
  color: rgb(212, 212, 212);
  box-shadow: 0 0 2px 1px #DDE6ED;
  transform: translate(100%, 0);
  visibility: hidden;
  opacity: 0;
}

.infobox-container-content {
  padding: 10px;
}

.infobox-container-title {
  background-color: #545454;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding-bottom: 8px;
  display: block;
  height: 20px;
  padding: 5px 20px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: content-box;
}

.infobox-container-visible {
  transform: translate(0, 0);
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

.infobox-row,
.infobox-flex-row {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  margin: 5px 0;
}
.infobox-row .first-item,
.infobox-flex-row .first-item {
  flex: 1;
  box-sizing: border-box;
  padding-bottom: 2px;
  font-weight: 100;
  font-size: smaller;
}
.infobox-row .second-item,
.infobox-flex-row .second-item {
  flex: 3;
  text-align: end;
  font-size: smaller;
}
.infobox-row .second-item > span,
.infobox-flex-row .second-item > span {
  margin: 0 2px;
  display: flex;
}
.infobox-row .wrap-item,
.infobox-flex-row .wrap-item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.infobox-row .xsmall-item,
.infobox-flex-row .xsmall-item {
  font-size: x-small;
}

.infobox-flex-row {
  justify-content: space-between;
}

.centered-line {
  height: 1px;
  background-color: rgb(68, 68, 68);
  margin: 5px 0;
}

@media (max-width: 768px) {
  .infobox-container {
    width: 75%;
    font-size: smaller;
  }
  .infobox-container-title {
    padding: 5px 10px;
    height: auto;
  }
  .infobox-row {
    flex-direction: column;
  }
  .infobox-row .wrap-item {
    justify-content: center;
  }
}
.infobox-container.highlight {
  animation: flash-highlight 1.5s ease;
}

@keyframes flash-highlight {
  0% {
    opacity: 1;
    background-color: rgba(30, 30, 30, 0.5);
  }
  100% {
    opacity: 0.5;
    background-color: rgb(60, 50, 50);
  }
}`, "",{"version":3,"sources":["webpack://./src/satmon/modules/InfoComponent/InfoComponent.scss","webpack://./src/satmon/assets/variables.scss"],"names":[],"mappings":"AAGA,uBAAA;AAEA;EACI,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EAEA,+BAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,yBC9BU;ED+BV,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,0BAAA;EACA,mBAAA;EACA,UAAA;EACA,0DAAA;AAJJ;;AAOA;;EAEI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAJJ;AAMI;;EACI,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAHR;AAMI;;EACI,OAAA;EACA,eAAA;EACA,kBAAA;AAHR;AAIQ;;EACI,aAAA;EACA,aAAA;AADZ;AAKI;;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAFR;AAKI;;EACI,kBAAA;AAFR;;AAMA;EACI,8BAAA;AAHJ;;AAMA;EACI,WAAA;EACA,iCAAA;EACA,aAAA;AAHJ;;AAOA;EACI;IACI,UAAA;IACA,kBAAA;EAJN;EAOE;IACI,iBAAA;IACA,YAAA;EALN;EAQE;IACI,sBAAA;EANN;EASE;IACI,uBAAA;EAPN;AACF;AAWA;EACI,oCAAA;AATJ;;AAaA;EACI;IACI,UAAA;IACA,uCAAA;EAVN;EAaE;IACI,YAAA;IACA,iCAAA;EAXN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100..900&display=swap');\n@import \"src/satmon/assets/variables\";\n\n/* New info component */\n\n.infobox-container {\n    font-family: \"Roboto Mono\", sans-serif;\n    font-size: smaller;\n    font-weight: 300;\n    letter-spacing: 2px;\n\n    width: 50%;\n    background: rgba(30, 30, 30, 0.5);\n    left: 50px;\n    border-radius: 8px;\n    display: block;\n    position: absolute;\n    top: 80px;\n    color: rgb(212 212 212);\n\n    box-shadow: 0 0 2px 1px $clr-primary-extra-light;\n    transform: translate(100%, 0);\n    visibility: hidden;\n    opacity: 0;\n}\n\n.infobox-container-content {\n    padding: 10px;\n}\n\n.infobox-container-title {\n    background-color: $clr-primary;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding-bottom: 8px;\n    display: block;\n    height: 20px;\n    padding: 5px 20px;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    box-sizing: content-box;\n}\n\n.infobox-container-visible {\n    transform: translate(0, 0);\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 0.2s ease-out, transform 0.2s ease-out;\n}\n\n.infobox-row,\n.infobox-flex-row {\n    display: flex;\n    flex-direction: row;\n    overflow: hidden;\n    margin: 5px 0;\n\n    .first-item {\n        flex: 1;\n        box-sizing: border-box;\n        padding-bottom: 2px;\n        font-weight: 100;\n        font-size: smaller;\n    }\n\n    .second-item {\n        flex: 3;\n        text-align: end;\n        font-size: smaller;\n        >span {\n            margin: 0 2px;\n            display: flex;\n        }\n    }\n\n    .wrap-item {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n\n    .xsmall-item {\n        font-size: x-small;\n    }\n}\n\n.infobox-flex-row {\n    justify-content: space-between;\n}\n\n.centered-line {\n    height: 1px;\n    background-color: rgb(68, 68, 68);\n    margin: 5px 0;\n}\n\n\n@media (max-width: 768px) {\n    .infobox-container {\n        width: 75%;\n        font-size: smaller;\n    }\n\n    .infobox-container-title {\n        padding: 5px 10px;\n        height: auto;\n    }\n\n    .infobox-row {\n        flex-direction: column;\n    }\n\n    .infobox-row .wrap-item {\n        justify-content: center;\n    }\n}\n\n\n.infobox-container.highlight {\n    animation: flash-highlight 1.5s ease;\n}\n\n\n@keyframes flash-highlight {\n    0% {\n        opacity: 1;\n        background-color: rgba(30, 30, 30, 0.5);\n    }\n\n    100% {\n        opacity: 0.5;\n        background-color: rgb(60, 50, 50);\n    }\n}","// Colors\n$clr-primary: #545454;\n$clr-secondary: #526D82;\n$clr-primary-light: #9DB2BF;\n$clr-primary-extra-light: #DDE6ED;\n$border: 1px solid #DDE6ED;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
